import instance, { ADMIN_PREFIX } from 'services/api';

/**
 * GET /excel/export-patients — server-rendered XLSX of the patients
 * list under the given filter set. Returned as a blob the FE pipes to
 * a download anchor.
 */
export const exportPatientsExcel = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  filters: Record<string, any>
) =>
  instance.get(`${ADMIN_PREFIX}/excel/export-patients`, {
    params: filters,
    responseType: 'blob'
  });
